import AvatarIcon from '@/components/AvatarIcon';
import { TBusiness } from '@/context/types/Business';
import { TCustomer } from '@/context/types/Customer';
import cn from '@/utils/cn';
import { routes } from '@/utils/routes';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BrandNameClassName = cn(['flex', 'items-center', 'text-sm', 'font-normal']);

interface UserIconProps {
  business?: TBusiness;
  customer: TCustomer;
}

export const UserIcon: React.FC<UserIconProps> = ({ business, customer }) => {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  useEffect(() => {
    if (business) {
      setName(business.name);
    } else {
      setName(customer!.name);
    }
  }, [business, customer]);

  return (
    <div className="flex gap-x-2 cursor-pointer" onClick={() => navigate(routes.home)}>
      <AvatarIcon key="avatar-name" name={name} />
      <span className={BrandNameClassName}>{name}</span>
    </div>
  );
};
